import Handler from '@/core/domain/usecase/handler';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import { Station } from '../../domain/model/station';

export interface CreateStationRepository {
  (data: object): Promise<Station>
}

const createStationRepository = (axios: AxiosInstance): CreateStationRepository => async (data: object) => {
  try {
    const response: AxiosResponse = await axios.post(`https://stationapihydra.com/station`,
      data
    )
    return response.data
  } catch (err: any | AxiosError) {
    if (err.isAxiosError) {
      throw new Handler().trataErro(err)
    } else {
      throw err
    }
  }
}

export default createStationRepository

